/**
 * AUFBAU von Linie und Pfeil (Grundformen der Vektor-Ebene, Jan 22.10.2026:
 * „Wäre schön, wenn Linie oder Pfeil sich auch aufbauen könnten“). Die
 * erzeugte SVG (app/src/lib/grundformen) trägt ein Clip-Rechteck
 * [data-aufbau-clip] (volle Breite in data-laenge) und beim Pfeil die Spitze
 * [data-aufbau-kopf] (wandert mit der Linienspitze, Weg in data-weg).
 * p = Fortschritt 0 … 1; ohne Fortschritts-Kanal ruft der Renderer mit 1.
 */
export function grundformAufbau(wurzel: Element, p: number): void {
    const q = Math.max(0, Math.min(1, Number.isFinite(p) ? p : 1));
    const stand = q.toFixed(4);
    // nur schreiben, wenn sich der Fortschritt geändert hat (läuft pro Frame)
    if (wurzel.getAttribute("data-aufbau-stand") === stand) return;
    wurzel.setAttribute("data-aufbau-stand", stand);
    wurzel.querySelectorAll("[data-aufbau-clip]").forEach((el) => {
        const voll = Number(el.getAttribute("data-laenge")) || 0;
        el.setAttribute("width", (voll * q).toFixed(2));
    });
    wurzel.querySelectorAll("[data-aufbau-kopf]").forEach((el) => {
        const weg = Number(el.getAttribute("data-weg")) || 0;
        el.setAttribute("transform", `translate(${(-(1 - q) * weg).toFixed(2)} 0)`);
        el.setAttribute("opacity", q > 0 ? "1" : "0");
    });
}
